import { AppComponent } from '@/../app/app.component';
import { appConfig } from '@/../app/app.config';
import { ecorEnv } from '@/../environments/environment';
import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';

if (ecorEnv.production) {
    enableProdMode();
}

bootstrapApplication(AppComponent, appConfig)
    .catch(err => console.error(err));

if (!navigator.cookieEnabled) {
    document.getElementById("initialLoading").innerHTML = "Please enable cookies for this site to continue...";
}